import React from "react";
import { Flex } from "antd";
import { validateHex, validateRgb } from "src/common/attrEdit";
import { MakeLabelParams } from "../../types/MakeLabelParams";
import styles from "./ColorView.module.less";
import { getAttrLabelTreeData } from "../../utils/getAttrLabelTreeData";

interface PropsColorView {
  params: MakeLabelParams;
}

export const ColorView: React.FC<PropsColorView> = ({ params }) => {
  const { attribute, labelTreeData } = params;
  const value = getAttrLabelTreeData(attribute, labelTreeData)?.labels?.[0];
  if (!value) return null;
  const showPreview = validateHex(value) || validateRgb(value);
  return (
    showPreview && (
      <Flex vertical>
        <div>{value}</div>
        <div className={styles.preview} style={{ backgroundColor: value }} />
      </Flex>
    )
  );
};
